import React from "react";
import { Button as BootstrapButton } from "reactstrap";
import PropTypes from "prop-types";

export default function Button(props) {
  const { className = "", children, isLoading, ...buttonProps } = props;

  return (
    <BootstrapButton className={`${className}`} {...buttonProps}>
      {!isLoading ? children : <div className="three-dots-loader"></div>}
    </BootstrapButton>
  );
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isLoading: PropTypes.bool
};

Button.defaultProps = {
  className: "",
  isLoading: false
};
